module.exports = __webpack_public_path__ + "media/customizations/moonlight/logo-7b77ce7d3c0144e31f3b1856e0994d7d.png";